import { render } from "./App.vue?vue&type=template&id=3f3fc71b&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@/assets/styles/mystyles.css?vue&type=style&index=0&id=3f3fc71b&scoped=true&lang=css&external"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f3fc71b"]])

export default __exports__